"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contact = void 0;
const react_1 = __importDefault(require("react"));
const consts_1 = require("../../common/consts");
require("./contact.scss");
// need an image for discord and email icons
const Contact = () => {
    return (react_1.default.createElement("section", { className: "contact-section", id: consts_1.SECTION_IDS.contact },
        react_1.default.createElement("h2", null, "Contact Us"),
        react_1.default.createElement("div", { className: "contact-methods-wrapper" },
            react_1.default.createElement("div", { className: "contact-method" },
                react_1.default.createElement("a", { href: `mailto:${consts_1.EMAIL_CONTACT}` },
                    react_1.default.createElement("img", { src: "/images/logos/email.svg", height: 50, alt: "email logo" })),
                react_1.default.createElement("p", null,
                    "Have questions or want to get in touch? Reach out to us via email at",
                    ' ',
                    react_1.default.createElement("a", { href: `mailto:${consts_1.EMAIL_CONTACT}` }, consts_1.EMAIL_CONTACT))),
            react_1.default.createElement("div", { className: "contact-method" },
                react_1.default.createElement("a", { href: consts_1.DISCORD_INVITE_URL },
                    react_1.default.createElement("img", { src: "/images/discord-logo.png", height: 50, alt: "discord logo" })),
                react_1.default.createElement("p", null,
                    "Join our ",
                    react_1.default.createElement("a", { href: consts_1.DISCORD_INVITE_URL }, "Discord"),
                    " community to chat with fellow board game enthusiasts, stay updated on events, and share your gaming experiences!")))));
};
exports.Contact = Contact;
